import * as React from 'react';
import type { SVGProps } from 'react';
const SvgPointer = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <path
      fill="currentColor"
      d="M5.726 22a.585.585 0 0 1-.586-.586V2.586a.585.585 0 0 1 1-.414l12.891 12.93a.585.585 0 0 1-.414 1h-6.789L6.14 21.828a.586.586 0 0 1-.414.172Z"
    />
  </svg>
);
export default SvgPointer;
